// FPTI event_name constants for Lighthouse Insightly onboarding
// Reference: https://paypal.atlassian.net/wiki/spaces/BFS/pages/2880650453

const PREFIX = 'ppbl_application'

const event = (name) => `${PREFIX}_${name}`

export const FPTI_EVENTS = {
	// Page Impressions
	PAGE: {
		COUNTRY_NOT_SUPPORTED: event('country_not_supported_page_shown'),
		INELIGIBLE_STATE: event('ineligible_state_page_shown'),
		UNSUPPORTED_ACCOUNT: event('unsupported_account_page_shown'),
		PAGE1: event('page1_shown'),
		OPEN_APPLICATION: event('open_application_page_shown'),
		PAGE2: event('page2_shown'),
		ADDRESS_NORMALIZATION_MODAL: event('address_normalization_modal_shown'),
		PAGE3: event('page3_shown'),
		PAGE4: event('page4_shown'),
		PAGE5: event('page5_shown'),
		SUBMISSION_LOADING: event('submission_loading_page_shown'),
		PENDING: event('pending_page_shown'),
		OFFER: event('offer_page_shown'),
		DISCLOSURE_MODAL: event('disclosure_modal_shown'),
		THANK_YOU: event('thank_you_page_shown'),
		CREDIT_FROZEN: event('credit_frozen_page_shown'),
		INELIGIBLE: event('ineligible_page_shown'),
		MAINTENANCE: event('maintenance_page_shown'),
		ERROR: event('error_page_shown'),
		SESSION_TIMEOUT: event('session_timeout_page_shown'),
	},

	// Click Events
	CLICK: {
		// Application flow
		PAGE_CONTINUE: {
			PAGE1: event('page1_continue_button_pressed'),
			PAGE2: event('page2_continue_button_pressed'),
			PAGE3: event('page3_continue_button_pressed'),
			PAGE4: event('page4_continue_button_pressed'),
			PAGE5: event('page5_continue_button_pressed'),
		},

		// Address normalization
		ADDRESS: {
			RECOMMENDED_SELECTED: event('address_recommended_selected'),
			DIALOG_CLOSED: event('address_normalization_dialog_closed'),
		},

		// Offer flow
		OFFER: {
			DISCLOSURE_OPEN: event('offer_disclosure_open_button_pressed'),
			DOWNLOAD: event('disclosure_download_button_pressed'),
			CHOOSE_ANOTHER: event('disclosure_choose_another_offer_pressed'),
			SIGN_AND_CONTINUE: event('offer_sign_and_continue_button_pressed'),
			ACCEPT_CONTINUE: event('offer_accept_continue_button_pressed'),

			TERM_SELECTED: {
				V1: event('offer_term_v1_selected'),
				V2: event('offer_term_v2_selected'),
			},

			AMOUNT: {
				INCREMENT: event('offer_amount_increment_button_pressed'),
				DECREMENT: event('offer_amount_decrement_button_pressed'),
				V1_INPUT: event('offer_amount_v1_input_changed'),
				V2_INPUT: event('offer_amount_v2_input_changed'),
			},
		},

		// Navigation
		NAVIGATION: {
			CONTINUE_TO_PORTAL: event('continue_to_portal_button_pressed'),
			ERROR_RESTART: event('error_restart_button_pressed'),
			PAGE_CHANGE: event('page_change_button_pressed'),
		},
	},

	// Form Events
	FORM: {
		FIELD_PRESSED: event('form_field_pressed'),
		VALIDATION_ERROR: event('form_field_validation_error_shown'),
	},
}
